export default __webpack_public_path__ + "static/media/Affinity_Rev_03.c830481c.svg";